import * as queryString from 'query-string';
import * as DomPurify from 'dompurify';

$(function () {
    const criteriaSelector$ = $('.ModCriteriaSelectorC');
    const submitButton$ = criteriaSelector$.find('[id$=CriteriaSelector_SubmitButton]');

    $("body").on("click", ".rha-sb-events+table a", () => { window.scroll(0, 0); });

    const criteriaSelectorMapToQueryParamKey: { [key: string]: string } = {
        'event location': 'eventLocation',
        'course': 'course',
        'training categories': 'course',
        'keyword': 'q',
        'postcode': 'postcode',
        'radius (miles)': 'radius',
        'city': 'city'
    }

    /**
     * @summary Determine whether the page is being rendered for the first time or is being loaded in response to a postback
     */
    function isPostBackPage() {
        if (!document.referrer) {
            return false;
        }
        // Remove query parameters when comparing the urls
        const documentReferrer = document.referrer.split("?")[0];
        const documentLocationHref = document.location.href?.split("?")[0];
        if (documentReferrer.indexOf(documentLocationHref) > -1) {
            return true;
        }

        return false;
    }

    /**
    * @summary Set up names on the criteriaSelectorController's wrappers with a value equal with their App_LocalResource label
    */
    function setupCriteriaSelectorNames() {
        const criteriaSelectorContainers$ = criteriaSelector$.find('[id*=CriteriaSelector_panelDynamicControl]');

        for (let i = 0; i < criteriaSelectorContainers$.length; i++) {
            const criteriaSelectorContainer$ = $(criteriaSelectorContainers$[i]);
            const criteriaSelectorLabel$ = criteriaSelectorContainer$.find('[id*=CriteriaSelector_labelDynamicControl]');

            const criteriaSelectorName = criteriaSelectorLabel$.text();
            criteriaSelectorContainer$.attr('data-criteria-selector-name', criteriaSelectorName.toLowerCase());
        }
    }

    /**
    * @summary Ensure that we look only at the criteriaSelectors whose label has been declared in "criteriaSelectorMapToQueryParamKey".
    */
    function isAHandledCriteriaField(criteriaSelectorName: string) {
        return !!criteriaSelectorMapToQueryParamKey[criteriaSelectorName.toLowerCase()];
    }

    /**
    * @summary Determine if a search has happened during the page's postback
    */
    function hasPostBackSearchBeenPerformed(criteriaSelectorsContainers$: JQuery<HTMLElement>[], queryParams: [key: string | null]) {
        if (!criteriaSelectorsContainers$?.length) {
            return;
        }

        return isPostBackPage() &&
            criteriaSelectorsContainers$.some(function (criteriaSelectorsContainer$: JQuery<HTMLElement>) {
                // Get selector name
                const criteriaSelectorName = criteriaSelectorsContainer$.attr('data-criteria-selector-name');

                // If it is not a handled controller, then ignore it to avoid any issues
                if (!isAHandledCriteriaField(criteriaSelectorName)) {
                    return false;
                }

                const criteriaSelectorsController$ = criteriaSelectorsContainer$.find('[id*=CriteriaSelector_DynamicControl]');

                const criteriaSelectorValue = `${criteriaSelectorsController$.val()}` || '';
                const queryParamKey = criteriaSelectorMapToQueryParamKey[criteriaSelectorName.toLowerCase()];
                const queryParamValue = DomPurify.sanitize(queryParams[queryParamKey] || '');

                return criteriaSelectorValue !== queryParamValue && criteriaSelectorValue.length > 0;
            });
    }

    /**
    * @summary Determine if a search has happened via query parameters
    */
    function hasQueryParamSearchBeenPerformed(criteriaSelectorsContainers$: JQuery<HTMLElement>[], queryParams: [key: string | null]) {
        if (!criteriaSelectorsContainers$?.length) {
            return;
        }

        let hasQueryParamSearchBeenDetected = false;

        criteriaSelectorsContainers$.forEach(function (criteriaSelectorsContainer$: JQuery<HTMLElement>) {
            // Get selector name
            const criteriaSelectorName = criteriaSelectorsContainer$.attr('data-criteria-selector-name');

            // If it is not a handled controller, then ignore it to avoid any issues
            if (!isAHandledCriteriaField(criteriaSelectorName)) {
                return false;
            }

            const criteriaSelectorsController$ = criteriaSelectorsContainer$.find('[id*=CriteriaSelector_DynamicControl]');
            const criteriaSelectorsControllerType = criteriaSelectorsController$.prop("tagName").toLowerCase();

            const criteriaSelectorValue = `${criteriaSelectorsController$.val()}` || '';
            const queryParamKey = criteriaSelectorMapToQueryParamKey[criteriaSelectorName.toLowerCase()];
            const queryParamValue = DomPurify.sanitize(queryParams[queryParamKey] || '');

            if (criteriaSelectorValue !== queryParamValue && (criteriaSelectorsControllerType !== "input" || criteriaSelectorValue.length === 0)) {
                if (!hasQueryParamSearchBeenDetected) {
                    hasQueryParamSearchBeenDetected = true;
                }

                // Update the control with the value passed in queryParam
                criteriaSelectorsController$.val(queryParamValue);

                if (criteriaSelectorsControllerType === "select") {
                    const newSelectedOption = criteriaSelectorsController$.find(`option[value="${queryParamValue}"]`);

                    if (newSelectedOption.length) {
                        const currentSelectedOption = criteriaSelectorsController$.find('option[selected="selected"]');

                        if (currentSelectedOption.length) {
                            currentSelectedOption.removeAttr('selected');
                        }

                        newSelectedOption.attr('selected', 'selected');
                    }
                }
            }
        });

        return hasQueryParamSearchBeenDetected;
    }

    function addSearchToHistory(criteriaSelectorsContainers$: JQuery<HTMLElement>[], replaceState: boolean = false) {
        if (!criteriaSelectorsContainers$?.length) {
            return;
        }

        let historyLocationSearch: { [key: string]: string } = {}

        criteriaSelectorsContainers$.forEach(function (criteriaSelectorsContainer$: JQuery<HTMLElement>) {
            // Get selector name
            const criteriaSelectorName = criteriaSelectorsContainer$.attr('data-criteria-selector-name');

            // If it is not a handled controller, then ignore it to avoid any issues
            if (!isAHandledCriteriaField(criteriaSelectorName)) {
                return false;
            }

            const criteriaSelectorsController$ = criteriaSelectorsContainer$.find('[id*=CriteriaSelector_DynamicControl]');
            const criteriaSelectorValue = `${criteriaSelectorsController$.val()}` || '';

            if (criteriaSelectorValue.length) {
                historyLocationSearch[criteriaSelectorMapToQueryParamKey[criteriaSelectorName.toLowerCase()]] = encodeURIComponent(criteriaSelectorValue);
            }
        });


        const historyLocationSearchStr = Object.keys(historyLocationSearch).reduce(function (locationSearchStr, queryParam, index) {
            const separator = index === 0 ? '?' : '&';
            return `${locationSearchStr}${separator}${queryParam}=${historyLocationSearch[queryParam]}`;
        }, '');


        let historyUrl = `${document.location.href.split('?')[0]}${historyLocationSearchStr}`;

        if (window.performance?.navigation?.type !== undefined) {
            if (window.performance.navigation.type === 2) {
                // if browser's back button was clicked
                return;
            }
        }

        if (replaceState) {
            history.replaceState(historyLocationSearch, document.title, historyUrl);
        }
        else {
            history.pushState(historyLocationSearch, document.title, historyUrl);
        }
    }

    function triggerPostbackSearch() {
        submitButton$.trigger('click');
    }

    if (criteriaSelector$.length && submitButton$.length) {
        setupCriteriaSelectorNames();

        const criteriaSelectorsContainers$ = criteriaSelector$.find(`[data-criteria-selector-name]`).toArray().map(e => $(e));
        const queryParameters = queryString.parse(location.search);

        if (criteriaSelectorsContainers$.length > 4) {
            const criteriaSelectorPanel$ = criteriaSelector$.find('div[id*=CriteriaSelector_pnl]');
            criteriaSelectorPanel$.css('flex-wrap', 'wrap');
        }

        if (hasPostBackSearchBeenPerformed(criteriaSelectorsContainers$, queryParameters)) {
            addSearchToHistory(criteriaSelectorsContainers$, false);
        } else if (hasQueryParamSearchBeenPerformed(criteriaSelectorsContainers$, queryParameters)) {
            addSearchToHistory(criteriaSelectorsContainers$, false);
            triggerPostbackSearch();
        }
    }
});
